import { fetchWithAuth } from "@/providers/auth-provider";
import { ServiceResponse } from "@/types/services";
import { CreateBoxInput, CreateBoxOutput } from "types/web-app";

export const createBox = async (accessToken: string, input: CreateBoxInput) => {
  try {
    const response = await fetchWithAuth("/box/create", accessToken, {
      method: "POST",
      body: JSON.stringify(input),
    });
    const data = (await response.json()) as ServiceResponse<CreateBoxOutput>;
    return data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};
